import * as React from 'react'

export const PayLaterIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 6V12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36C30.6274 36 36 30.6274 36 24H33C33 28.9706 28.9706 33 24 33C19.0294 33 15 28.9706 15 24C15 19.0294 19.0294 15 24 15V22.7747C24 24.0112 24.4055 24.0078 25.5114 23.9985C25.6127 23.9977 25.72 23.9968 25.8333 23.9968H33C32.9982 19.0277 28.9695 15 24 15V12C30.6263 12 35.9982 17.3708 36 23.9968H42V24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6Z"
          fill="#0070E0"
        />
      </svg>
    )
  },
)

PayLaterIcon.displayName = 'PayLaterIcon'
